/**
 * INSPECTEURS DE PAGE — le contrat.
 *
 * Chaque inspecteur édite UN sujet d'une page (son identité, son fond, son
 * contenu, ses scores, ses suites) et ne connaît rien de l'écran qui le monte.
 * C'est ce qui permet au composeur de les poser dans des onglets, et à
 * n'importe quel autre écran de réutiliser exactement le même formulaire —
 * cette configuration a longtemps été écrite deux fois, une par éditeur, et les
 * deux copies avaient divergé.
 *
 * Props communes :
 *   page            — le document de page (brouillon ou état serveur)
 *   onPatch(fields) — modifie des champs de PREMIER niveau (title, tags…)
 *   onPatchContent(fields) — modifie des champs de `content`
 *   ctx             — le décor : { scoreDic, allDecisions, allPages, territories,
 *                     pageTerritory, token, isNew }
 *
 * Les deux callbacks fusionnent, ils ne remplacent pas : un inspecteur écrit ce
 * qu'il change, jamais l'objet entier.
 */

/** Scores de l'atelier, en options pour RefSelect. */
export function scoreOptionsOf(scoreDic) {
  return Object.entries(scoreDic || {}).map(([key, s]) => ({
    value: key, label: s.name, sublabel: s.type,
  }));
}

/**
 * Scores affichables en anneau. Un donut compare un état courant à un état de
 * référence : sans `metadata.standard` ET `metadata.current`, il n'a rien à
 * dessiner. Proposer les autres, c'est proposer un écran vide.
 */
export function doughnutScoreOptionsOf(scoreDic) {
  return Object.entries(scoreDic || {})
    .filter(([, s]) => s.metadata && s.metadata.standard && s.metadata.current)
    .map(([key, s]) => ({ value: key, label: s.name, sublabel: s.type }));
}

/**
 * Retrouve une décision par ID, qu'elle vienne du catalogue complet ou de la
 * page elle-même (`/get_complete_page` la résout, `/get_page` non).
 */
export function findDecision(ctx, decId) {
  if (!decId) return null;
  const fromCatalog = (ctx.allDecisions || []).find((d) => d._id === decId);
  if (fromCatalog) return fromCatalog;
  const resolved = (ctx.page?.content?.list_decisions || []).find(
    (d) => typeof d === "object" && d?._id === decId
  );
  return resolved || null;
}
